import { ReactComponent as WebServImg } from '../images/undraw_futuristic-interface_sv51.svg';
import { ReactComponent as LeadServImg } from '../images/undraw_savings_uwjn.svg';
import { ReactComponent as ItServImg } from '../images/undraw_server-cluster_7ugi.svg';
import Hero from '../components/Hero';
import NavAndHero from '../components/NavAndHero';
import Service from '../components/Service';
import AboutSection from '../components/About';
import CallToAction from '../components/CTA';
import Footer from '../components/Footer';

const Homepage = () => {
  return (
    <div data-theme="light">
      <NavAndHero />
      <Hero />

      <section className='py-16 px-4 bg-base-100'>
        <div className='text-center mb-12'>
          <h1 className='text-3xl md:text-4xl font-bold text-base'>Our Services</h1>
          <p className='my-2 text-center text-gray-400'>Everything you need to supercharge your online presence!</p>
        </div>

        <div className='flex flex-wrap justify-center'>
          <Service
            SvgIcon={WebServImg}
            title="Website & Branding"
            description="Custom websites and branding that build trust and convert local visitors into clients."
            buttonText="Learn More"
          />
          <Service
            SvgIcon={LeadServImg}
            title="Online Marketing"
            description="Get more leads with targeted ads, SEO, and social media marketing campaigns that drive real results."
            buttonText="Learn More"
          />
          <Service
            SvgIcon={ItServImg}
            title="IT Services"
            description="Reliable IT support and smart tech solutions for small businesses across the GTA."
            buttonText="Learn More"
          />
        </div>
      </section>

      <div className='flex w-full flex-col'>
        <div className="divider"></div>
      </div>

      <AboutSection />
      <div id='cta'>
        <CallToAction /> 
      </div>
      <Footer />
    </div>
  );
};

export default Homepage;
